import shared from './shared';

const sharedConstants = shared.CONSTANTS || {};

const constants = {
    AUTH0_DOMAIN: sharedConstants.AUTH0_DOMAIN,
    AUTH0_API_AUDIENCE: sharedConstants.AUTH0_API_AUDIENCE,
    AUTH0_SPA_CLIENT_ID: sharedConstants.AUTH0_SPA_CLIENT_ID,
    WS_PROTOCOL: sharedConstants.WS_PROTOCOL,
    DEMO_ACCOUNTS: sharedConstants.DEMO_ACCOUNTS,
    STRIPE_PAYMENT_LINK: sharedConstants.STRIPE_PAYMENT_LINK,
    ANALYTIC_PROVIDERS: sharedConstants.ANALYTIC_PROVIDERS,
    ENABLED_ANALYTIC_PROVIDERS: sharedConstants.ENABLED_ANALYTIC_PROVIDERS,
    SHOPIFY_INSTALLATION_URL: sharedConstants.SHOPIFY_INSTALLATION_URL,

    // Client-side constants
    FILE_PICKER_API_KEY: 'AsyAkZKX5QaueSd7BCjgnz',
    FILE_PICKER_CDN: 'https://cdn.fs.atlas.so',
    FILE_UPLOADS_CDN: 'https://files.atlas.so',
    SUPPORT_EMAIL: 'support@getatlas.io',
    CSRF_TOKEN: shared.csrfToken,
};

export default constants;

// #region Tests

if (import.meta.vitest) {
    const { describe, test, expect } = import.meta.vitest;
    describe('constants', () => {
        test('it is an object', () => {
            expect(constants).toHaveProperty('AUTH0_DOMAIN');
            expect(constants).toHaveProperty('AUTH0_API_AUDIENCE');
            expect(constants).toHaveProperty('AUTH0_SPA_CLIENT_ID');
            expect(constants).toHaveProperty('WS_PROTOCOL');
            expect(constants).toHaveProperty('DEMO_ACCOUNTS');
            expect(constants).toHaveProperty('STRIPE_PAYMENT_LINK');
            expect(constants).toHaveProperty('ANALYTIC_PROVIDERS');
            expect(constants).toHaveProperty('ENABLED_ANALYTIC_PROVIDERS');
            expect(constants).toHaveProperty('FILE_PICKER_API_KEY');
            expect(constants).toHaveProperty('SUPPORT_EMAIL');
            expect(constants).toHaveProperty('CSRF_TOKEN');
        });
    });
}

// #endregion
